import { X } from "lucide-react";

import type { ActivityItem } from "@/lib/api";

interface ActivityDrawerProps {
  item: ActivityItem | null;
  onClose: () => void;
}

export function ActivityDrawer({
  item,
  onClose,
}: ActivityDrawerProps): JSX.Element | null {
  if (!item) return null;
  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-ink/30"
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className="fixed right-0 top-0 bottom-0 z-50 w-[480px] max-w-[90vw] overflow-auto border-l border-line bg-card shadow-panel"
        role="dialog"
        aria-label="Dettaglio attività"
      >
        <header className="flex items-start justify-between gap-3 border-b border-line p-4">
          <div className="min-w-0">
            <p className="font-code text-label text-ink-3">
              {item.kind}
            </p>
            <h3 className="truncate text-lg font-semibold tracking-tight">
              {item.message}
            </h3>
          </div>
          <button
            type="button"
            className="btn btn-icon-sm btn-ghost"
            onClick={onClose}
            aria-label="Chiudi"
          >
            <X className="ic" strokeWidth={1.6} aria-hidden="true" />
          </button>
        </header>
        <div className="space-y-4 p-4 text-sm">
          <dl className="grid grid-cols-[120px_1fr] gap-y-2 font-mono text-xs">
            <dt className="text-ink-3">Quando</dt>
            <dd>{new Date(item.ts).toLocaleString("it-IT")}</dd>
            <dt className="text-ink-3">Attore</dt>
            <dd>{item.actor}</dd>
            {item.marketplace_id && (
              <>
                <dt className="text-ink-3">Marketplace</dt>
                <dd>{item.marketplace_id}</dd>
              </>
            )}
            {item.sku && (
              <>
                <dt className="text-ink-3">SKU</dt>
                {/* Testo e non link: la pagina per-SKU non esiste più e Prodotti non legge lo SKU dall'indirizzo. */}
                <dd>{item.sku}</dd>
              </>
            )}
            {item.duration_ms != null && (
              <>
                <dt className="text-ink-3">Durata</dt>
                <dd>{item.duration_ms} ms</dd>
              </>
            )}
            {item.success != null && (
              <>
                <dt className="text-ink-3">Esito</dt>
                <dd
                  className={
                    item.success ? "text-accent" : "text-destructive"
                  }
                >
                  {item.success ? "OK" : "KO"}
                </dd>
              </>
            )}
          </dl>
          <details open>
            <summary className="cursor-pointer text-xs font-semibold text-ink-3">
              Payload
            </summary>
            <pre className="mt-2 overflow-auto rounded-md bg-paper-2 p-3 text-xs leading-relaxed">
              {JSON.stringify(item.payload, null, 2)}
            </pre>
          </details>
        </div>
      </aside>
    </>
  );
}
